<template>
  <div class="py-12 text-center text-white bg-black lg:text-left">
    <div class="px-6 mx-auto max-w-7xl text-muted">

      <div class="overflow-hidden bg-gray-900 rounded-lg shadow-xl lg:grid lg:grid-cols-2 lg:gap-4">
        <div class="px-6 pt-10 pb-12 sm:pt-16 sm:px-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
          <div class="lg:self-center">
            <h2 class="text-3xl font-bold leading-tight text-white sm:text-4xl">
              Ready to scale and streamline your fleet?
            </h2>
            <router-link :to="{ name: 'Register' }" class="mt-8 btn btn-primary btn-xl">
              Start a Free Trial &rarr;
            </router-link>
          </div>
        </div>
        <div class="relative -mt-6 pb-3/5 md:pb-1/2">
          <img class="absolute inset-0 object-cover object-left-top w-full h-full transform translate-x-6 translate-y-6 rounded-md sm:translate-x-8 lg:translate-y-20" src="/images/ui/booking-list.png" alt="Fleetbeacon App">
        </div>
      </div>
  
      <div class="flex flex-col items-center pt-12 text-gray-400 md:flex-row">
        <div class="w-full space-y-1 lg:w-1/2">
          <div class="space-x-4">
            <router-link class="text-gray-400" :to="{ name: 'Reseller' }">Become A Reseller</router-link>
            <router-link class="text-gray-400" :to="{ name: 'TermsOfService' }">Terms of Service</router-link>
            <router-link class="text-gray-400" :to="{ name: 'PrivacyPolicy' }">Privacy Policy</router-link> 
          </div>
          <div class="mt-4 text-gray-500">&copy; 2017 - {{ new Date().getFullYear() }} Fleetbeacon (Pty) Ltd.</div>
        </div>
        <div class="w-full mt-4 lg:w-1/2">
          <img src="/images/webfleet-partner-badge.png" alt="WEBFLEET.connect Registered Partner" class="h-20 mx-auto rounded shadow-xl lg:mr-0 lg:ml-auto">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SiteFooter'
  }
</script>
